import { styles as commonStyles } from '../../assets/common.scss';
import { styles } from './template.scss';

export const templatePhasrSidePanel = document.createElement('template');

templatePhasrSidePanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='gz-phasr-side-panel-wrapper'>
      <gz-button type="quiet" class="back-button hidden" color="secondary" buttonheight="small" id="backButton" buttonfontsize="small" theme="light">
          <gz-icon name="ds-icon-arrow_left_collapse" size="24" color="secondary"></gz-icon>
          <span id="backButtonText">Back</span>
      </gz-button>
    <gz-title class='side-panel-title' fontWeight='500' fontSize='16'></gz-title>
    <gz-label-switch class='side-panel-label-switch hidden' itemLeft="{}" itemRight="{}"></gz-label-switch>
    <div id="searchContainer" class="search-container hidden">
        <gz-input-search id="firstSearchInput" placeholder="Search" searchOnAction="true"></gz-input-search>
        <gz-input-search id="secondSearchInput" placeholder="Search" searchOnAction="true" class="hidden"></gz-input-search>
    </div>
    <div class="phasr-list-container">
        <gz-phasr-list id='firstList' hasMoreItems></gz-phasr-list>
        <gz-phasr-list id='secondList' class="hidden" hasMoreItems></gz-phasr-list>
    </div>
    <div id="actionButtonsContainer" class="action-buttons-container hidden">
      <gz-button type="full" color="primary" id="firstActionButton"></gz-button>
    </div>
  </div>
`;
